import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { BreadcrumbsModule } from '@shared/components/breadcrumbs/breadcrumbs.module';
import { SiteMapComponent } from './site-map.component';

@NgModule({
    declarations: [
        SiteMapComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        BreadcrumbsModule,
    ]
})
export class SiteMapModule { }
